"use strict";

(function(z){

    z.NirForm = z.FormView.extend({
        el:"#nirform-modal",

        UPLOAD_MAX_SIZE: 10000000,
        UPLOAD_ALLOWED_TYPES: [
            'text/csv',
            'text/plain'
        ],

        events: function() {

            return _.extend({}, z.FormView.prototype.events,{
                "click #nirform-import-upload-button": "_onUploadClick",
            });
        },

        _bindModel: function(model){
            model = _.isUndefined(model) ? this.model : model;
            Backbone.Validation.unbind(this, {model: model});
            Backbone.Validation.bind(this, {
                valid: this._onValid.bind(this),
                invalid: this._onInvalid.bind(this),
                model: model
            });
        },

        /**
         * Constructor.
         *
         * @return {undefined}
         */
        initialize: function() {
            this._bindModel();
            // this._initializeInvoiceCheck();
            // this._bindEvents();
            z.FormView.prototype.initialize.apply(this, arguments);
        },

        _bindEvents: function(){
            // this.listenTo(this.model, 'request', this._onModelRequest);
            // this.listenTo(this.model, 'sync', this._onModelSync);
            // this.listenTo(this.model, 'error', this._onModelError);
        },

        /**
         * Method that renders the form
         *
         * @return {Object} - this object
         */
        render: function() {

            // Clean up the form
            this._cleanupForm();

            z.FormView.prototype.render.apply(this, arguments);

            // Initialize the chosen fields
            // this._initializeChosen();

            var title = this.getModalFormEditTitleText();

            // if (this.$el.find('.modal-title').text() === title) {
            //
            //     this.$el.find("#nirform-partNumber-field").prop("disabled", true);
            //     this.$el.find("#nirform-type-field").prop("disabled", true);
            // } else {
            //
            //     this.$el.find("#nirform-partNumber-field").prop("disabled", false);
            //     this.$el.find("#nirform-type-field").prop("disabled", false);
            // }


            return this;
        },

        /**
         * Get add entity route name.
         *
         * @return {string} - add entity route name
         */
        getAddEntityRouteName: function() {
            return 'addNir';
        },

        /**
         * Get edit entity route name.
         *
         * @return {string} - edit entity route name
         */
        getEditEntityRouteName: function() {
            return 'editNir';
        },

        /**
         * Get modal form add title text
         *
         * @return {string} - modal form add title text
         */
        getModalFormAddTitleText: function() {
            return Translator.trans('js.btn_add_nir');
        },

        /**
         * Get modal form edit title text
         *
         * @return {string} - modal form edit title text
         */
        getModalFormEditTitleText: function() {
            return Translator.trans('js.btn_edit_nir');
        },

        /**
         * Get error panel container id.
         *
         * @return {string} - the error panel id
         */
        getErrorPanelId: function() {
            return '#nirform-error-panel';
        },

        /**
         * Get submit button selector.
         *
         * @return {string} - the submit button selector
         */
        getSubmitButtonSelector: function() {
            return '#nirform-save-button';
        },

        /**
         * Get page path.
         *
         * @return {string} - the page path
         */
        getPagePath: function() {
            return 'nir';
        },

        /**
         * Get success event name.
         *
         * @return {string} - the success event name
         */
        getSuccessEventName: function() {
            return 'nir.success';
        },
        _onModelRequest: function(){
            this._setLoading(true);
            // this._isLoading(true);
        },

        _onModelSync: function(){
            this._setLoading(false);
            // this._isLoading(false);
        },

        _onModelError: function(model, res){
            this._setLoading(false);
            // this._isLoading(false);
        },
        /**
         * Get form error message text.
         *
         * @return {string} - form error message text
         */
        getFormErrorMessageText: function() {
            return Translator.trans('js.error_message_nirform');
        },


        _onUploadClick: function(e) {
            e.preventDefault();

            this._hideMessages();

            var fileInput = document.querySelector('#import-template-field');
            var invoiceNumber = document.querySelector('#nirform-invoiceNumber-field');
            var sapSupplier = document.querySelector('#nirform-sapSupplierId-field');

            if (!sapSupplier || !sapSupplier.value) {
                this._showError('Selectează un id de furnizor!');
                return;
            }

            if (!invoiceNumber || !invoiceNumber.value) {
                this._showError('Selectează un numar de factura!');
                return;
            }

            // verificări inițiale
            if (!fileInput || !fileInput.files.length) {
                this._showError('Selectează un fișier pentru import!');
                return;
            }

            var file = fileInput.files[0];

            if (!this._isValidUploadType(file.type)) {
                this._showError('Tipul fișierului nu este permis! Acceptate: CSV.');
                return;
            }

            if (!this._isValidUploadSize(file.size)) {
                this._showError('Fișierul este prea mare! Dimensiune maximă 10MB.');
                return;
            }
            this._initializeInvoiceCheck();
        },

        _hideMessages: function(){
            this.$('#import-errors').addClass('hidden').fadeOut('fast');
            var $success = $('#import-success-message');
            $success.addClass('hidden').hide();
        },

        _isValidUploadType: function(type){
            return this.UPLOAD_ALLOWED_TYPES.indexOf(type) >= 0;
        },

        _isValidUploadSize: function(size){
            return size <= this.UPLOAD_MAX_SIZE;
        },

        _getFormData: function(){
            var data = new FormData();
            var fileInput = document.querySelector('#import-template-field');
            var invoiceNumber = document.querySelector('#nirform-invoiceNumber-field');
            var sapSupplier = document.querySelector('#nirform-sapSupplierId-field');

            if (fileInput && fileInput.files.length > 0) {
                data.append('nir_form[template]', fileInput.files[0]);
            }
            if (sapSupplier && sapSupplier.value) {
                data.append('nir_form[sapSupplierId]', sapSupplier.value);
            }
            if (invoiceNumber && invoiceNumber.value) {
                data.append('nir_form[invoiceNumber]', invoiceNumber.value);
            }
            return data;
        },

        _initializeInvoiceCheck: function () {
            var $invoiceInput = this.$('#nirform-invoiceNumber-field');
            var lastCheckedValue = null;

            var invoiceNumber = document.querySelector('input[name="nir_form[invoiceNumber]"]').value;

            lastCheckedValue = invoiceNumber;
            var valid = false;
            Backbone.ajax({
                url: '/nir/check-invoice',
                type: 'POST',
                data: { invoiceNumber: invoiceNumber },
                success: function (res) {
                    if (res.exists == true) {
                        if (confirm('Acest nr de factura a mai fost folosit deja la un alt NIR. Continuati?'))
                        {
                            this._uploadTemplate();
                        }
                    }
                    else if(res.exists == false) {
                        this._uploadTemplate();
                    }
                }.bind(this),
                error: function () {

                    valid = false;
                    return valid;

                }.bind(this)
            });
        },

        _uploadTemplate: function(){
            this._setLoading(true);
            // this._isLoading(true);
            var data = this._getFormData(this.model);

            Backbone.ajax({
                url: '/nir/import',
                type: 'POST',
                data: data,
                processData: false,
                contentType: false,
                success: function(res) {
                    this._setLoading(false);
                    // this._isLoading(false);

                    var data = res.data || {};
                    var errors = res.errors || [];

                    if (!data && !data.length) {
                        errors.push("Importul de piese a esuat.");
                    }

                    this._showImportMessages(data, errors);
                    // this._resetForm();
                }.bind(this),
                error: function(xhr){
                    this._setLoading(false);
                    // this._isLoading(false);
                    // this._isLoading(false);
                    if (xhr.responseJSON && xhr.responseJSON.errors) {
                        if (typeof xhr.responseJSON.errors == 'string')
                        {
                            errors = xhr.responseJSON.errors;
                        }
                        else{
                            var errors = [];
                            errors = xhr.responseJSON.errors.map(e => e.message);
                        }
                    } else {
                        errors.push("Eroare la import. Verificați fișierul!");
                    }

                    this._showImportMessages({}, errors);
                }.bind(this)
            });
        },


        /**
         * Collecting data from form inputs.
         *
         * @private
         * @return {Object} {{name: *, sapMaterialNumber: *, price: *}}
         */
        getFormData: function() {

            // Get the fields
            var $nameField     = this.$('#materialform-name-field');
            // var $sapIdField   = 'hardcodeddump';// this.$('#extraservicesform-sapId-field');
            var $partNumberField   = this.$('#materialform-partNumber-field');
            var $partTypeField   = this.$('#materialform-type-field');
            var $aquisitionPriceField   = this.$('#materialform-aquisitionPrice-field');
            var $commodityCodeField   = this.$('#materialform-commodityCode-field');
            var $locationField   = this.$('#materialform-location-field');
            var $statusField   = this.$('#materialform-status-field');

            return {
                'name'     : $nameField.val(),
                'type'   : $partTypeField.val(),
                'partNumber'   : $partNumberField.val(),
                'aquisitionPrice'   : $aquisitionPriceField.val(),
                'commodityCode'   : $commodityCodeField.val(),
                'location'   : $locationField.val(),
                'status'   : $statusField.val()
            };
        },

        /**
         * Method used to show a general error message if the user is
         * browsing the app on mobile
         *
         * @return {undefined}
         */
        showMobileAlert: function()
        {
            var errorMessage = Translator.trans('js.nir_create_error_message_mobile');

            // Display mobile alert
            this.$el.find('#nir-create-general-error-panel')
                .removeClass('hidden')
                .text(errorMessage)
                .fadeTo('slow', 1)
                .delay(3000)
                .fadeTo('slow', 0, function(){
                    this.hideMobileAlert();
                }.bind(this));
        },

        /**
         * Method used to hide the error message if the form is submitted, or the modal has been closed
         *
         * @return {undefined}
         */
        hideMobileAlert: function()
        {
            this.$el.find('#nir-create-general-error-panel').addClass('hidden');
        },

        /**
         * Method that resets the form fields, resets the collections and
         * hides the tables holding data
         *
         * @private
         * @return {undefined}
         */
        _cleanupForm: function() {

            // Resetting form
            this._resetFields("nirform");
        },

        /**
         * Method that hides the wrapper that holds the table
         *
         * @param {Object} $wrapperName - the div object that acts as a wrapper
         * @private
         * @return {undefined}
         */
        _hideWrapper: function($wrapperName) {

            $wrapperName.addClass("hidden");
        },


        /**
         * Method that resets the specified fields according to id passed
         *
         * @param {string} value Name of the id to search for
         * @private
         * @return {undefined}
         */
        _resetFields: function (value) {

            this.$('[id^=' + value + ']').val("");
        },


        /**
         * Method that binds validation to the chosen model
         *
         * @param {object} model The model that the validation is being performend on
         * @private
         * @return {undefined}
         */
        _bindValidation: function(model) {

            model = _.isUndefined(model) ? this.model : model;
            Backbone.Validation.unbind(this, {model: model});

            Backbone.Validation.bind(this, {
                valid: this._onValid.bind(this),
                invalid: this._onInvalid.bind(this),
                model: model
            });
        },

        /**
         * Display the error message
         *
         * @param {string} message The message to be shown
         * @private
         * @return {undefined}
         */
        _showError: function(message) {
            // TODO: move in abstract class to be reused

            var errorMessage = Translator.trans('js.nir_create_error_message_mobile');

            // Display mobile alert
            this.$el.find('#nir-create-general-error-panel')
                .removeClass('hidden')
                .text(message)
                .fadeTo('slow', 1)
                .delay(3000)
                .fadeTo('slow', 0, function(){
                    this.hideMobileAlert();
                }.bind(this));
        },

        _displayError: function(res){
            console.log(res.responseJSON);
            var errors = res.responseJSON.errors;

            if (errors.length !== 0) {

                var message = errors;

                if (typeof res.responseJSON != "undefined")
                {
                    this._showError(message);
                }
            }
            // this._resetForm();
        },

        /**
         * Method that handles the form submission
         *
         * @param {Event} e - the event
         * @return {undefined}
         * @private
         */
        _onSubmitForm: function (e) {

            e.preventDefault();

            // Get form data
            var formData = this.getFormData();
            this.model.set(formData);

            var isValid = this.model.isValid(true);

            if( !isValid ){
                this.showMobileAlert();
                return;
            }

            // this._isLoading(true, this.getSubmitButtonSelector());

            // Save the material
            this.model.save(null, {

                success: function (i) {

                    this.model.trigger("success", i);
                }.bind(this),
                error: function(model, res) {

                    if (res == "Commodity code not found in SAP")
                    {
                        res = "Commodity codul introdus nu există în lista de coduri valide."
                    }
                    // Showing error messages
                    this._displayError(res);
                    // this._isLoading(false, this.getSubmitButtonSelector());

                }.bind(this)
            });
        },

        _setLoading: function(loading){
            var $spinner = this.$('#import-loading');
            if (loading) {
                $spinner.show();
            } else {
                $spinner.hide();
            }
        },

        _showImportMessages: function(data, errors) {
            var $error = this.$('#nir-create-general-error-panel');
            $error.empty();

            if (errors && errors.length) {
                // this.modal.modal("hide");
                if (typeof errors == 'string') {
                    $('<span>').addClass('help-block text-left text-danger').text(errors).appendTo($error);
                    var $error = $('#nir-create-general-error-panel');
                    $error.text(errors)
                        .removeClass('hidden');
                } else {
                    errors.forEach(function (msg) {
                        $('<span>').addClass('help-block text-left text-danger').text(msg).appendTo($error);
                    });
                    this.$('#nir-create-general-error-panel').removeClass('hidden').fadeIn('slow');
                }


            }
            if (data && data.length) {
                var $success = $('#import-nir-success-message');
                $success.empty();

                data.forEach(function (data) {
                    var baText = '';

                    if (data.BaTransfer !== '')
                    {
                        baText = ' (piesele au fost alocate proiectelor indicate)';
                    }

                    $('<div>')
                        .text(
                            'Receptia comenzii Depanero nr. ' + data.nirOrderId +
                            ' cu SAP ID ' + data.sapPurchaseOrderId +
                            ' pentru furnizorul ' + data.sapSupplierId +
                            ' in gestiunea ' + data.storageLocation +
                            ' a fost inregistrata cu SAP ticket ' + data.SapPurchaseTicket + baText
                        )
                        .appendTo($success);
                });

                this.modal.modal("hide");
                $success
                    .removeClass('hidden')
                    .fadeOut(0).fadeIn('slow')
                    .delay(10000)
                    .fadeOut('slow', function () {
                        $success.addClass('hidden');
                    });
            }

        }


    });

})(window.z = window.z || {});
